export class User {
    id: string;
    username: string;
    email: string;
    phone_number: string; 
    roles: string[]; 
    token?: string;
    password?: string     // use only in case of PW reset
    new_password?: string // use only in case of PW reset
    
  constructor(
    id: string, 
    username: string, 
    email: string, 
    phone_number: string, 
    roles: string[], 
    token?: string,
    password?: string,
    new_password?: string
) {
    this.id = id;
    this.username = username;
    this.email = email;
    this.phone_number = phone_number;
    this.roles = roles;
    this.token = token ?? ""
    this.password = password ?? ""
    this.new_password = new_password ?? ""
  }
    
}

export interface UserQuery {
 description: string,
}

export enum Role {
  admin = 'Administrator',
  b2b = 'B2B',
  b2c = 'B2C',
  volantino = "volantino"
}

export interface ResetPassword
{
    Password: string,
    ConfirmPassword: string,
    Email: string,
    Token: string
}